<style scoped="scoped" lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/type/change/time/page" getKey="rows"
			:columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('shebeimingcheng')">
						<yi_data_select :multiple="true" :type="'equipment'" :ids.sync="yt.conditions.equipmentIds">
						</yi_data_select>
					</el-form-item>
					<el-form-item :label="$t('huanxingcaozuo')">
						<yi_dictionary_select :type="'TYPE_CHANGE_OPERATOR'" :ids.sync="yt.conditions.operator">
						</yi_dictionary_select>
					</el-form-item>
					<el-form-item :label="$t('shifouqiyong')">
						<el-select v-model="yt.conditions.enable">
							<el-option :label="$t('shi')" :value="1"></el-option>
							<el-option :label="$t('fou')" :value="0"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button @click="yt.get(1)" type="primary" plain="plain">
							{{ $t('sousuo') }}
						</el-button>
						<el-button @click="yt.clear()">{{ $t('chongzhi') }}
						</el-button>
						<yi_curd_expand_button></yi_curd_expand_button>
					</el-form-item>
				</el-form>
			</template>
			<!-- 左侧按钮插槽 -->
			<template #buttonsL>
				<el-button v-if="utils.checkPower('web_scheduling_changeover_time_create')" size="mini"
					@click="yt.showEditDialog('xinzeng', null, 'w1'); setAddEnable()" type="primary">
					{{ $t('xinzeng') }}
				</el-button>
				<el-button style="margin-left: 10px;" v-if="utils.checkPower('web_scheduling_changeover_time_batch_import')"  size="mini" @click="importExcelShow = !importExcelShow" plain>
					{{ $t('daoru') }}
				</el-button>
			</template>
			<!-- 右侧按钮插槽 -->
			<!-- <template #buttonsR>
				<el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"  @click="yt.showColumnsDialog()"></el-button>
				</el-button>
			</template> -->
			<!-- 自定义某个字段 -->

			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button v-if="utils.checkPower('web_scheduling_changeover_time_update')" type="text"
							@click="yt.showEditDialog('bianji', scope.row, 'w1')">{{ $t('bianji') }}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button v-if="utils.checkPower('web_scheduling_changeover_time_delete')" type="text"
							class="font-color-danger" @click="yt.remove(scope.row, '/web/type/change/time/delete')">
							{{ $t('shanchu') }}
						</el-button>
					</el-col>
				</el-row>
			</template>
		</yi_curd_table>

		<!-- 新增/编辑弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 新增表单 -->
			<template v-if="yt.editObj.action == 'xinzeng'">
				<!-- <div class="dialog-scroller"> -->
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('shebeimingcheng')" required>
						<yi_data_select :type="'equipment'" :ids.sync="yt.editObj.equipmentId">
						</yi_data_select>
					</el-form-item>
					<el-form-item :label="$t('huanxingcaozuo')" required>
						<yi_dictionary_select :type="'TYPE_CHANGE_OPERATOR'" :ids.sync="yt.editObj.operator">
						</yi_dictionary_select>
					</el-form-item>
					<el-form-item :label="$t('huanxingshijian')" required>
						<!-- <el-input v-model="yt.editObj.time"></el-input> -->
						<yi_number_input :min="1" :type="'number'" :start.sync="yt.editObj.time">
						</yi_number_input>
					</el-form-item>
					<el-form-item :label="$t('shifouqiyong')" required>
						<el-select v-model="yt.editObj.enable">
							<el-option :label="$t('shi')" :value="1"></el-option>
							<el-option :label="$t('fou')" :value="0"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<!-- </div> -->
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
					<el-button :loading="yt.editObj.loading" size="mini"
						@click="yt.req('POST', '/web/type/change/time/create')" type="primary">
						{{ $t('baocun') }}
					</el-button>
				</span>
			</template>
			<!-- 更新表单 -->
			<template v-if="yt.editObj.action == 'bianji'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('shebeimingcheng')" class="noborder">
						<yi_data_select disabled :type="'equipment'" :ids.sync="yt.editObj.equipmentId">
						</yi_data_select>
					</el-form-item>
					<el-form-item :label="$t('huanxingcaozuo')" class="noborder">
						<yi_dictionary_select disabled :type="'TYPE_CHANGE_OPERATOR'" :ids.sync="yt.editObj.operator">
						</yi_dictionary_select>
					</el-form-item>
					<el-form-item :label="$t('huanxingshijian')" required>
						<yi_number_input :min="1" :type="'number'" :start.sync="yt.editObj.time">
						</yi_number_input>
					</el-form-item>
					<el-form-item :label="$t('shifouqiyong')" required>
						<el-select v-model="yt.editObj.enable">
							<el-option :label="$t('shi')" :value="true"></el-option>
							<el-option :label="$t('fou')" :value="false"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
					<el-button :loading="yt.editObj.loading" size="mini"
						@click="yt.req('POST', '/web/type/change/time/update')" type="primary">
						{{ $t('baocun') }}
					</el-button>
				</span>
			</template>
		</el-dialog>
		<!-- 导入excel -->
		<importExcel :show.sync="importExcelShow" />
	</div>
</template>
<script type="text/javascript">
import importExcel from '@@/pages/web/scheduling/changeover_time/import_excel';
export default {
	name: 'web_scheduling_changeover_time_list',
	components: {
		importExcel
	},
	data() {
		return {
			importExcelShow: false,
			columns: [{
				label: 'shebeimingcheng',
				prop: 'equipment.name',
			}, {
				label: 'huanxingcaozuo',
				prop: 'operator',
				type: 'dictionary',
				key: 'TYPE_CHANGE_OPERATOR',
			}, {
				label: 'huanxingshijian',
				prop: 'time',
			}, {
				label: 'shifouqiyong',
				prop: 'enable',
				type: 'bool',
			}, {
				label: 'chuangjianren',
				prop: 'createByObject.nickname',
			}, {
				label: 'chuangjianshijian',
				prop: 'createTime',
				type: 'time',
				format: 'YYYY-MM-DD'
			}, {
				label: 'caozuo',
				type: 'slot',
				width: 150,
				fixed: 'right'
			}]
		};
	},
	created() {
		setTimeout(() => {
			this.yt.get(1);
		}, 300)
		this.$watch("yt.editObj.time", (newVal, oldVal) => {
			// 在这里执行判断逻辑
			this.checkChangeTime();
		});

	},

	methods: {
		checkChangeTime() {
			if (this.yt.editObj.time < 0) {
				this.$message.error(this.$t("huanxingshijianbixushizhengzhengshu"));
				this.yt.editObj.time = ""
			}
		},
		editCustomerType() {

			this.yt.editObj.loading = true
			let params = this.utils.copy(this.yt.editObj)
			this.http.post('/web/customer/editCustomerType', params).then((res) => {
				this.utils.successMessage(this.$t(res.msg));
				this.yt.get(1);
				this.yt.isShowEditDialog = false
			}).catch((msg) => {
				this.utils.errorMessage(msg);
			}).finally(() => {
				this.yt.editObj.loading = false
			})
		},

	}
};
</script>